import React from 'react';

const generateProductSchema = (product, currency, seoReviewsData = []) => {
  const {
    productName,
    storeItemNumber,
    longDescription,
    imageSet,
    prices,
    published,
    productPageUrl,
  } = product;

  let reviewsSchemna = [];

  const isPublished = published ? 'http://schema.org/InStock' : 'http://schema.org/OutOfStock';

  if (seoReviewsData?.length > 0) {
    reviewsSchemna = seoReviewsData.map((userReview) => {
      const {
        userNickname, title, reviewText, rating, datePublished,
      } = userReview;
      return {
        '@type': 'Review',
        author: userNickname,
        datePublished,
        name: title,
        description: reviewText,
        reviewRating: {
          '@type': 'Rating',
          ratingValue: rating,
          bestRating: '5.0',
          worst: '1.0',
        },
      };
    });
  }

  const schema = {
    '@context': 'http://schema.org',
    '@type': 'Product',
    name: productName,
    SKU: storeItemNumber,
    image: imageSet.prod?.[0].mainImageSrc, // kicId
    url: `${window.location.protocol}//${window.location.hostname}${productPageUrl}`,
    description: longDescription,
    offers: {
      '@type': 'Offer',
      url: `${window.location.protocol}//${window.location.hostname}${productPageUrl}`,
      availability: isPublished,
      priceSpecification: [
        ...(prices.list.discountPrice
          ? [
            {
              '@type': 'UnitPriceSpecification',
              price: prices.list.offerPriceUSD,
              priceCurrency: currency,
            },
          ]
          : []),
        {
          '@type': 'UnitPriceSpecification',
          price: prices.list.listPriceUSD,
          priceCurrency: currency,
          priceType: 'https://schema.org/ListPrice',
        },
      ],
    },
    ...(seoReviewsData?.length > 0 && { review: reviewsSchemna }),
  };

  return schema;
};

const SeoSchema = ({
  productDetail, seoReviewsData, currency,
}) => {
  const scriptTag = `<script type="application/ld+json">${JSON.stringify(
    generateProductSchema(productDetail, currency, seoReviewsData),
  )}</script>`;

  // eslint-disable-next-line react/no-danger
  return <div dangerouslySetInnerHTML={{ __html: scriptTag }} />;
};

export default SeoSchema;
